/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resource: "airHandlerUnit" | "network" | "room", source: NonNullable<unknown> }} Duplicate_ToInputs */



/**
* | resource | output |
* | --- | --- |
* | "airHandlerUnit" | "Duplicate days from {source} to other units" |
* | "network" | "Duplicate days from {source} to other networks" |
* | "room" | "Duplicate days from {source} to other rooms" |
*
* @param {Duplicate_ToInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duplicate_to = /** @type {((inputs: Duplicate_ToInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_ToInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Duplicate days from ${i?.source} to other units`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Duplicate days from ${i?.source} to other networks`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Duplicate days from ${i?.source} to other rooms`);
		return /** @type {LocalizedString} */ ("duplicate_to");
	}
	{
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Dupliquer des jours de ${i?.source} vers d'autres équipements`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Dupliquer des jours de ${i?.source} vers d'autres réseaux`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Dupliquer des jours de ${i?.source} vers d'autres pièces`);
		return /** @type {LocalizedString} */ ("duplicate_to");
	}
});